const Eye = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14.1213 14.1214C14.6839 13.5588 15 12.7958 15 12.0001C15 11.2045 14.6839 10.4414 14.1213 9.8788C13.5587 9.31619 12.7956 9.00012 12 9.00012C11.2044 9.00012 10.4413 9.31619 9.87868 9.8788C9.31607 10.4414 9 11.2045 9 12.0001C9 12.7958 9.31607 13.5588 9.87868 14.1214C10.4413 14.6841 11.2044 15.0001 12 15.0001C12.7956 15.0001 13.5587 14.6841 14.1213 14.1214Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.45801 12.0001C3.73201 7.94312 7.52301 5.00012 12 5.00012C16.478 5.00012 20.268 7.94312 21.542 12.0001C20.268 16.0571 16.478 19.0001 12 19.0001C7.52301 19.0001 3.73201 16.0571 2.45801 12.0001Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Eye;
